import React from 'react';
import './About.css';
import { FaBolt, FaBullseye, FaLightbulb } from 'react-icons/fa';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="section-header">
          <h2>About SyncWithVikash</h2>
          <p>Professional Mobile App Development</p>
        </div>
        
        <div className="about-content">
          <div className="about-text">
            <h3>Flutter & iOS Developer</h3>
            <p>
              Hi, I'm Vikash Kumar Sharma, a Flutter & iOS developer with hands-on experience 
              building and publishing production-ready mobile applications. I specialize in 
              creating scalable apps across healthcare, education, enterprise workflow, 
              document management, and commerce domains.
            </p>
            <p>
              With 11+ published applications and expertise in Flutter architecture, Provider 
              state management, REST API integration, and clean UI implementation, I deliver 
              solutions that combine technical excellence with user-focused design.
            </p>
            
            <div className="about-features">
              <div className="feature">
                <div className="feature-icon">
                  <FaBolt />
                </div>
                <div>
                  <h4>Fast Delivery</h4>
                  <p>Production-ready apps with quick turnaround and clean code</p>
                </div>
              </div>
              
              <div className="feature">
                <div className="feature-icon">
                  <FaBullseye />
                </div>
                <div>
                  <h4>Result Focused</h4>
                  <p>Building apps that solve real business problems</p>
                </div>
              </div>
              
              <div className="feature">
                <div className="feature-icon">
                  <FaLightbulb />
                </div>
                <div>
                  <h4>Modern Solutions</h4>
                  <p>Using latest Flutter, iOS, and mobile development technologies</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="about-skills">
            <h3>Technical Expertise</h3>
            <div className="skills-grid">
              <div className="skill-item">
                <h4>Mobile Development</h4>
                <p>Flutter, iOS (Swift), Xcode</p>
              </div>
              <div className="skill-item">
                <h4>State Management</h4>
                <p>Provider, Dio, REST APIs</p>
              </div>
              <div className="skill-item">
                <h4>Backend & APIs</h4>
                <p>Node.js, MongoDB, SQL</p>
              </div>
              <div className="skill-item">
                <h4>Integrations</h4>
                <p>Razorpay, Firebase, SignalR</p>
              </div>
              <div className="skill-item">
                <h4>Design Tools</h4>
                <p>Figma, Canva, UI/UX</p>
              </div>
              <div className="skill-item">
                <h4>Advanced Features</h4>
                <p>AI, QR, PDF/Excel, Charts</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
